<template>
  <div v-if="isVisible && newUi === false" :class="getToastColor()" class="rounded-md">
    <div class="flex text-white w-full mt-2">
      <div class="left-0 px-1 py-3 w-11/12 flex items-center">
        <img :src="toastIcon" class="text-2xl px-3" />
        <span
          class="text-sm justify-center items-center"
          v-html="toastMessage"
        />
      </div>
      <div class="flex items-start mt-3">
        <button @click="closeToast">
          <i class="fas fa-times text-white" />
        </button>
      </div>
    </div>
    <button
      class="ml-12 text-white mt-1 mb-3 hover:underline px-1"
      v-if="notification.event !== undefined"
      @click="goToRoute()"
    >
      Show it
    </button>
    <button
      v-if="
        toastLink.course_id &&
        (toastLink.roundtable_id || toastLink.live_discussion_id)
      "
      @click="goToRoundTable()"
      class="ml-12 text-white mt-1 mb-3 hover:underline px-1"
    >
      {{ toastLink.follow_up ? 'Create Follow Up' : 'Jump to RoundTable' }}
    </button>
    <button
      v-if="myPortfolio.id"
      @click="goToMyPortfolio()"
      class="ml-12 text-white mt-1 mb-3 hover:underline px-1"
    >
      Go to My Portfolio
    </button>
    <button
      v-if="upgrade === true"
      @click="handleUpgrade()"
      class="ml-12 text-white mt-1 mb-3 hover:underline px-1"
    >
      Upgrade Account
    </button>
  </div>
</template>
<script>
  import Vue from 'vue';
  import store from 'store';
  import authenticationService from 'features/authentication/authentication.services';
  import profileServices from 'services/profile/profileServices';
  import config from 'services/apiConfigs';
  import { EventBus } from '../../../../utils/event-bus';

  export default Vue.extend({
    data() {
      return {
        isVisible: true,
      };
    },
    props: {
      toastMessage: {
        type: String,
        default() {
          return '';
        },
      },
      newUi: {
        type: Boolean,
        default: false,
      },
      toastType: {
        type: String,
        default: 'Info',
      },
      toastTime: {
        type: Number,
        default: 0,
      },
      notification: {
        type: Object,
        default() {
          return {};
        },
      },
      toastLink: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
      myPortfolio: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
      upgrade: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      toastIcon() {
        switch (this.toastType) {
          case 'Info':
            return require('./info.svg');
          case 'Success':
            return require('./success.svg');
          case 'Genie':
            return require('./genie_wand-magic-sparkles.svg');
          case 'Warning':
            return require('./warning.svg');
          case 'Error':
            return require('./warning.svg');
          case 'Nudge':
            return require('./nudger_white.svg');
          default:
            return require('./info.svg');
        }
      },
    },

    methods: {
      handleUpgrade: function() {
        Vue.router.push({ name: 'profile.membership'});
        this.isVisible = false;
        this.$emit('close');
      },
      closeToast: async function () {
        this.$emit('close');
        this.isVisible = false;
        this.toastType = '';
        this.toastMessage = '';
        if (this.toastLink.follow_up) {
          if (this.toastLink.roundtable_id) {
            await store.dispatch('savingRTDetails', {
              id: this.toastLink.roundtable_id,
              is_start_follow_up_notification: false,
            });
            return;
          }
          await store.dispatch('saveLiveDiscussionSettings', {
            id: this.toastLink.live_discussion_id,
            is_start_follow_up_notification: false,
          });
          return;
        }
      },
      toastCloseRoute: async function () {
        this.$emit('close');
        this.isVisible = false;
        this.toastType = '';
        this.toastMessage = '';
        return;
      },
      getToastColor() {
        let toastColor = '';
        switch (this.toastType) {
          case 'Info':
            toastColor = 'bg-sky-400 hover:bg-sky-500';
            break;
          case 'Success':
            toastColor = 'bg-emerald-500 hover:bg-emerald-400';
            break;
          case 'Genie':
            toastColor = 'bg-pinky';
            break;
          case 'Warning':
            toastColor = 'bg-yellow-500';
            break;
          case 'Error':
            toastColor = 'bg-red-500';
            break;
          case 'Nudge':
            toastColor = 'bg-sky-400 hover:bg-sky-500';
            break;
          default:
            toastColor = 'bg-gray-500 hover:bg-gray-700';
        }
        return toastColor;
      },
      goToRoute() {
        const notifications = this.notification;
        store.dispatch('navigateFromNotification', notifications);
        store.commit('setIsFromNotification', true);
      },
      goToRoundTable: function () {
        if (this.toastLink.follow_up === true) {
          Vue.router.replace({
            query: {
              follow_up: true,
            },
          });
          return;
        }
        if (this.toastLink.roundtable_id) {
          Vue.router.push({
            name: 'roundtable.index',
            params: {
              courseID: this.toastLink.course_id,
              roundtableID: this.toastLink.roundtable_id,
            },
          });
          return;
        }
        Vue.router.push({
          name: 'live-discussion.index',
          params: {
            courseID: this.toastLink.course_id,
            liveDiscussionID: this.toastLink.live_discussion_id,
          },
        });
      },
      goToMyPortfolio() {
        if (!this.myPortfolio.profile_url) {
          profileServices
            .createProfile(this.myPortfolio.id)
            .then(({ data }) => {
              const profileUrl = `${config.universeURL}/profiles/${data.profile_url}`;
              authenticationService.navigateToExternalWithAuth(profileUrl);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const profileUrl = `${config.universeURL}/profiles/${this.myPortfolio.profile_url}`;
          authenticationService.navigateToExternalWithAuth(profileUrl);
        }
      },
    },
    created() {
      if (this.toastTime !== 0) {
        setTimeout(() => {
          this.closeToast();
        }, this.toastTime);
      }
      EventBus.$on('close_toast', () => {
        this.toastCloseRoute();
        EventBus.$off('close_toast');
      });
    },
  });
</script>



// WEBPACK FOOTER //
// plToast.vue?096a4aec